import { Link } from "react-router-dom";

var BookDisplay = require("components/reading/books/BookDisplay")
var CurrentUser = require("lib/account/CurrentUser");
var GradeLevel = require("lib/academic/GradeLevel.js");
var RecentQuizzesDisplayData = require("autograder/recent_quizzes.json");
var Features = require("lib/account/Features");

var AnimateOwl = require("lib/games/AnimateOwl");
var Owlvatar = require("components/avatars/Owlvatar");
var OnboardingAvatarData = require("onboarding-avatar.json")

class OnboardingStageGenericCompletion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
		};
	}

	render() {
		var completionText = "You will get automatic quiz grades, but your students will only get positive reinforcement.";
		var nextStepsText = "Add your students now to hold them accountable for their independent reading in a better way!";
		var buttonText = "Add Students";
		var buttonPath = "/roster?addNewStudentsButton=true";

		var leftContent = (
			<span ref="avatar" className="studentOwlvatar">
				<Owlvatar maxWidth={ 200 } maxHeight={ 200 }
					patches={ OnboardingAvatarData.patches }
					colors={ OnboardingAvatarData.colors } />
			</span>
		);

		var actionsContent = (
			<div className="actionsContainer">
				<Link className="btn buttonPrimary newStudentsButton" to={ buttonPath }>
					<span className="newTaskText">{ buttonText }</span>
				</Link>
			</div>
		);

		return (
			<div className="onboardingStage onboardingStageGenericCompletion">
				<div className="leftCol">
					{ leftContent }
				</div>
				<div className="rightCol completionSection">
					<p className="completionActionContainer">
						<span className="completionText">
							{ completionText }
							<br/>
							<br/>
							{ nextStepsText }
						</span>
					</p>

					{ actionsContent }
				</div>
			</div>
		);
	}

	componentDidMount() {
		AnimateOwl.dance_controller(100, $(this.refs.avatar), 1)

	}
}

OnboardingStageGenericCompletion.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	endOnboarding: PropTypes.func.isRequired,
	onComplete: PropTypes.func.isRequired,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageGenericCompletion;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageGenericCompletion.js